module.exports = __webpack_public_path__ + "img/icon_4_42.b2e09b28.png";